<template>
    <table class="table classificationPlanOuterTable" v-if="classificationPlan">
        <thead>
        <tr>
            <th class="classificationLabelName">{{$t('text.classificationPlanMetadata.classificationLabelName')}}</th>
            <th class="classificationLabel">{{$t('text.classificationPlanMetadata.classificationLabel')}}</th>
            <th class="rokHrambe">{{$t('text.classificationPlanMetadata.expiration')}}</th>
            <th class="povezaniSistemi">{{$t('text.classificationPlanMetadata.connectedSystems')}}</th>
            <th class="vpisnik">{{$t('text.classificationPlanMetadata.registry')}}</th>
            <th class="usageEndDate">{{$t('text.treeStructureForPrint.usageEndDate')}}</th>
        </tr>

        </thead>
        <tbody>
<!--            <tr>-->
<!--                <td colspan="6" class="innerTableContainerCell">-->
                    <TreeItemForPrint
                            class="item"
                            v-for="(item, index) in classificationPlan"
                            :item="item"
                            @select-item="$emit('select-item', $event)"
                            :key="index"
                            :selectedClassLabel="selectedClassLabel"
                            :toExport="toExport"
                            :move="move"
                            :printMode="printMode"
                    ></TreeItemForPrint>
<!--                </td>-->
<!--            </tr>-->
        </tbody>
    </table>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faHome} from '@fortawesome/free-solid-svg-icons'
    import {VueGoodTable} from 'vue-good-table';
    import axios from 'axios/index';
    import TreeItemForPrint from '../components/TreeItemForPrint';

    library.add(faHome);

    export default {
        name: 'TreeStructureForPrint',
        props: {
            selectedClassLabel: String,
            toExport: Boolean,
            classificationPlan: Array,
            move: {type: Boolean, default: false},
            printMode: Boolean,
        },
        components: {
            TreeItemForPrint,

        },
        mounted() {
            //console.log(this.classificationPlan);
        },
        data() {
            return {}

        },

        computed: {},
        methods: {}
    };
</script>

<style>
    @media print {
        /*table {*/
        /*    page-break-inside: auto;*/
        /*    border-collapse: collapse*/
        /*}*/

        /*tr {*/
        /*    page-break-inside: avoid;*/
        /*    page-break-after: auto*/
        /*}*/

        /*thead {*/
        /*    display: table-header-group;*/
        /*    page-break-after: avoid;*/
        /*    page-break-inside: avoid;*/
        /*    page-break-before: avoid;*/
        /*}*/

        /*tfoot {*/
        /*    display: table-footer-group*/
        /*}*/
    }
</style>



// WEBPACK FOOTER //
// src/components/TreeStructureForPrint.vue